import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import { Add, Remove } from '@material-ui/icons';
import { Tooltip } from '@material-ui/core';

const styles = {
  root: {
    maxWidth: 400,
    flexGrow: 1,
  },
};

class FontSizeStepper extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeStep: 2,
      onChange: (e) => props.onChange(e)
    };
  }

  handleNext = () => {
    this.state.onChange(2)
    this.setState(state => ({
      activeStep: state.activeStep + 1,
    }));
  };

  handleBack = () => {
    this.state.onChange(-2)
    this.setState(state => ({
      activeStep: state.activeStep - 1,
    }));
  };

  render() {
    const { classes, theme } = this.props;

    return (
      <MobileStepper
        variant="progress"
        steps={6}
        position="static"
        activeStep={this.state.activeStep}
        style={{backgroundColor:'transparent'}}
        className={classes.root}
        nextButton={
          <Tooltip title="Increase Font Size">
            <Button size="small" onClick={this.handleNext} disabled={this.state.activeStep === 5}>
              {theme.direction !== 'rtl' ? <Add/> : <Remove/>}
            </Button>
          </Tooltip>
        }
        backButton={
          <Tooltip title="Decrease Font Size">
            <Button size="small" onClick={this.handleBack} disabled={this.state.activeStep === 0}>
              {theme.direction === 'rtl' ? <Add /> : <Remove />}
            </Button>
          </Tooltip>
        }
      />
    );
  }
}

FontSizeStepper.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(FontSizeStepper);


// WEBPACK FOOTER //
// ./src/views/ChatPage/chatPageComponents/sidebar/ChatPageSettings/SettingsCompoments/fontSizeStepper.jsx